import React from "react";
import FroalaEditor from "react-froala-wysiwyg";
import "froala-editor/js/froala_editor.pkgd.min.js";

// Import required Froala plugins
import "froala-editor/js/plugins/align.min.js";
import "froala-editor/js/plugins/char_counter.min.js";
import "froala-editor/js/plugins/code_view.min.js"; // Code view plugin for HTML source editing
import "froala-editor/js/plugins/colors.min.js";
import "froala-editor/js/plugins/font_family.min.js";
import "froala-editor/js/plugins/font_size.min.js";
import "froala-editor/js/plugins/image.min.js";
import "froala-editor/js/plugins/link.min.js";
import "froala-editor/js/plugins/lists.min.js";
import "froala-editor/js/plugins/paragraph_format.min.js";
import "froala-editor/js/plugins/table.min.js";
import "froala-editor/js/plugins/special_characters.min.js";

interface FroalaEditorComponentProps {
  value: string;
  onChange: (content: string) => void;
  placeholder?: string;
  height?: any;
  readonly?: boolean;
  isPublished?: boolean;
}

const FroalaEditorComponent: React.FC<FroalaEditorComponentProps> = ({
  value,
  onChange,
  placeholder = "Enter text here...",
  height = 300,
  readonly = false,
  isPublished = false,
}) => {
  const handleModelChange = (content: string) => {
    if (!isPublished) {
      onChange(content);
    }
  };

  return (
    <FroalaEditor
      tag="textarea"
      model={value}
      onModelChange={handleModelChange}
      config={{
        key: "te1C2sE6B5B4C5E3H3jC1QUd1Xd1OZJ1ABVJRDRNGGUE1ITrE1D4A3A10B1B6F6B1G4E3==",
        placeholderText: placeholder,
        height: height,
        toolbarButtons: [
          "html", // This button enables the Code View
          "bold",
          "italic",
          "underline",
          "|",
          "formatOL",
          "formatUL",
          "outdent",
          "indent",
          "|",
          "align",
          "insertLink",
          "insertTable",
          "insertImage",
          "specialCharacters",
        ],
        pluginsEnabled: [
          "align",
          "table",
          "link",
          "image",
          "lists",
          "code_view",
          "specialCharacters",
        ],
        htmlAllowedTags: [".*"], // Allows any HTML tag to be edited
        htmlAllowedAttrs: [".*"], // Allows any HTML attributes
        readonly: isPublished || readonly,
      }}
    />
  );
};

export default FroalaEditorComponent;
